export default {
  selection: "System Language Selection",
  english: "English",
  simplified_chinese: "中文（简体）",
  list: {
    en: "English",
    zh: "Chinese (CN)",
    tw: "Chinese (TW)",
    vi: "Vietnamese",
    th: "Thai",
    id: "Indonesian",
    malay: "Malay",
    jp: "Japanese",
    kr: "Korean",
    my: "Myanmar",
    ar: "Argentina",
    ru: "Russia",
    ne: "Nepalese",
    bn: "Bangla"
  }
};
